import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '64px',
    margin: theme.spacing(4, 0, 2, 0),
  },
  headerText: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(0.5),
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(0.5),
    gap: theme.spacing(1),
  },
  buttonContainer: {
    margin: theme.spacing(2, 0),
  },
  buttonInner: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
  },
  icon: {
    fill: 'none',
    fontSize: '12px',
  },
}));

export default useStyles;
